(() => {
  document.querySelectorAll('[data-gallery]').forEach((gallery) => {
    const panels = [...gallery.querySelectorAll('[data-gallery-panel]')];
    const thumbs = [...gallery.querySelectorAll('[data-gallery-select]')];
    const counter = gallery.querySelector('[data-gallery-count]');
    let active = Math.max(0, panels.findIndex((panel) => !panel.hidden));
    const select = (index, focus = false) => {
      if (!panels.length) return;
      active = (index + panels.length) % panels.length;
      panels.forEach((panel, i) => {
        panel.hidden = i !== active;
        if (i !== active) {
          panel.querySelectorAll('video').forEach((video) => video.pause());
          panel.querySelectorAll('iframe').forEach((frame) => { if (frame.dataset.played) frame.src = frame.src; });
        } else panel.querySelectorAll('iframe').forEach((frame) => { frame.dataset.played = 'true'; });
      });
      thumbs.forEach((thumb, i) => thumb.setAttribute('aria-current', String(i === active)));
      if (counter) counter.textContent = `${active + 1} / ${panels.length}`;
      const caption = gallery.querySelector('[data-gallery-caption]');
      if (caption) caption.textContent = panels[active]?.querySelector('img')?.alt || '';
      const thumb = thumbs[active];
      if (thumb) { const strip = thumb.parentElement; if (strip.scrollWidth > strip.clientWidth) strip.scrollTo({ left: Math.max(0, thumb.offsetLeft - strip.offsetLeft - strip.clientWidth / 2 + thumb.clientWidth / 2), behavior: 'instant' }); if (focus) thumb.focus({ preventScroll: true }); }
    };
    thumbs.forEach((thumb, i) => {
      thumb.addEventListener('click', () => select(i));
      thumb.addEventListener('keydown', (event) => {
        if (['ArrowLeft', 'ArrowRight', 'Home', 'End'].includes(event.key)) {
          event.preventDefault();
          select(event.key === 'Home' ? 0 : event.key === 'End' ? panels.length - 1 : active + (event.key === 'ArrowRight' ? 1 : -1), true);
        }
      });
    });
    gallery.querySelector('[data-gallery-prev]')?.addEventListener('click', () => select(active - 1));
    gallery.querySelector('[data-gallery-next]')?.addEventListener('click', () => select(active + 1));
    const stage = gallery.querySelector('[data-gallery-stage]'); let start = null;
    stage?.addEventListener('touchstart', (event) => { const t = event.changedTouches[0]; start = { x: t.clientX, y: t.clientY }; }, { passive: true });
    stage?.addEventListener('touchend', (event) => { if (!start) return; const t = event.changedTouches[0], dx = t.clientX - start.x, dy = t.clientY - start.y; if (Math.abs(dx) > 60 && Math.abs(dx) > Math.abs(dy) * 1.5) select(active + (dx < 0 ? 1 : -1)); start = null; }, { passive: true });
    const dialog = gallery.querySelector('[data-media-dialog]');
    gallery.querySelectorAll('[data-zoom-source]').forEach((button) => button.addEventListener('click', () => {
      const image = dialog.querySelector('[data-dialog-image]'); image.removeAttribute('srcset'); image.removeAttribute('sizes'); image.src = button.dataset.zoomSource; image.alt = button.querySelector('img').alt;
      dialog.showModal(); document.documentElement.classList.add('media-is-open');
    }));
    gallery.querySelector('[data-close-dialog]')?.addEventListener('click', () => dialog.close());
    dialog?.addEventListener('close', () => document.documentElement.classList.remove('media-is-open'));
    dialog?.addEventListener('click', (event) => { if (event.target === dialog) dialog.close(); });
    if (counter) counter.textContent = `${active + 1} / ${panels.length}`;
      const caption = gallery.querySelector('[data-gallery-caption]');
      if (caption) caption.textContent = panels[active]?.querySelector('img')?.alt || '';
  });
})();
